import hero1 from "assests/hero-1.jpg";
import hero2 from "assests/hero-2.jpg";

import hero1AR from "assests/hero-1-ar.jpg";
import hero2AR from "assests/hero-2-ar.jpg";
import "./style.css";
// gsp
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { useLayoutEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
gsap.registerPlugin(ScrollTrigger);

const Hero = ({ data }) => {
  const component = useRef();
  const slider = useRef();
  const { i18n } = useTranslation();

  const datas = [
    {
      bg: i18n.language === "ar" ? hero1AR : hero1,
      image: data?.image,
      logo: data?.logo,
    },
    {
      bg: i18n.language === "ar" ? hero2AR : hero2,
      image: "",
      logo: "",
      title: data?.about_content?.title,
      subTitle: data?.about_content?.sub_title,
      text: data?.about_content?.text,
    },
  ];

  useLayoutEffect(() => {
    if (window.innerWidth > 992) {
      let ctx = gsap.context(() => {
        let panels = gsap.utils.toArray(".panel");
        const direction = i18n.language === "ar" ? 1 : -1;
        gsap.to(panels, {
          xPercent: direction * 100 * (panels.length - 1),

          ease: "none",
          scrollTrigger: {
            trigger: slider.current,
            pin: true,
            scrub: 0,
            snap: 0,
            end: "+=3500",
          },
        });
      }, component);

      return () => ctx.revert();
    }
  });

  return (
    <section
      ref={component}
      className="hidden xl:block slider-parent bg-primary "
    >
      <div className="slider-container" ref={slider}>
        {datas?.map(({ image, bg, logo, title, subTitle, text }, index) => (
          <div
            key={index}
            className="flex h-[100vh] items-center gap-x- panel-background about-panel panel"
            style={{ backgroundImage: `url(${bg})` }}
          >
            {image && (
              <div>
                <img
                  className={`${
                    i18n.language === "ar"
                      ? "mr-32 xxl:mr-44"
                      : "ml-32 xxl:ml-44"
                  }  mb-10 w-3/4 h-3/4 spinenr`}
                  src={image}
                  alt=""
                />
              </div>
            )}

            {logo && (
              <div className="">
                <img
                  className={`w-[20rem] ${
                    i18n.language === "ar"
                      ? "mr-40 xxl:mr-48"
                      : "ml-40 xxl:ml-48"
                  }  xxl:w-[22rem]`}
                  src={logo}
                  alt=""
                />
              </div>
            )}

            <div className="w-1/2 ml-40 text-white">
              <div className="">
                {title && (
                  <h4 className="titles-font text-lg capitalize">{title}</h4>
                )}

                {subTitle && (
                  <h6 className="titles-font text-4xl xxl:text-5xl text-secondary capitalize">
                    {subTitle}
                  </h6>
                )}
                {text && <p className="mt-4 font- w-3/4 xxl:text-lg">{text}</p>}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Hero;
